module.exports = __webpack_public_path__ + "img/pro_three_4.42f7af2f.jpg";